import moment from "moment"

const config = {
  pagination: false,
  rowSelection: false,
  fieldControl: false,
  columns: [
    {
      title: '报价类型',
      dataIndex: 'typeDisplay',
      name: 'typeDisplay',
      width: 120,
    },
    {
      title: '备注',
      dataIndex: 'description',
      width: 200,
      ellipsis: true,
      name: 'description',
    },
    {
      title: '变更原因',
      dataIndex: 'changeReasonStr',
      width: 200,
      ellipsis: true,
      name: 'changeReasonStr',
    },
    {
      title: '报价金额(元)',
      dataIndex: 'contractAmount',
      width: 120,
      name: 'contractAmount',
    },
    {
      title: '创建人',
      dataIndex: 'createdByName',
      width: 120,
      name: 'createdByName',
    },
    {
      title: '创建时间',
      dataIndex: 'createdTime',
      width: 160,
      name: 'createdTime',
      render: (text: any, record: any) => {
        return text ? moment(text).format('YYYY-MM-DD HH:mm:ss') : ''
      },
    },
    {
      title: '报价状态',
      dataIndex: 'stateDisplay',
      width: 120,
      name: 'stateDisplay',
    },
    {
      title: '是否冻结',
      dataIndex: 'frozenFlag',
      name: 'frozenFlag',
      width: 120,
      render: (text: any, record: any) => {
        return text ? '是' : '否'
      },
    },
    {
      title: '操作',
      key: 'action',
      width: 220,
      render: 'operation',
      fixed: 'right',
    },
  ],
  // footer: [
  //   {
  //     label: '新增报价',
  //     type: 'primary',
  //     events: ['onClick:handleAddQuotation'],
  //   },
  //   {
  //     label: '新增衣柜设计师',
  //     type: 'primary',
  //     auth: 'bidAdddWardrobeDesigner',
  //     events: ['onClick:bidAdddWardrobeDesignerHandle'],
  //   },
  //   {
  //     label: '图纸管理',
  //     type: 'primary',
  //     events: ['onClick:drawingManagementHandle'],
  //   },
  //   {
  //     label: '量房申请',
  //     type: 'primary',
  //     auth: 'measurementApply',
  //     events: ['onClick:amountRoomApplyHandle'],
  //   },
  //   {
  //     label: '刷新',
  //     type: 'primary',
  //     events: ['onClick:reload'],
  //   },
  // ],
}

export default config
export const toolConfig = [
  // {
  //   key: 'designServiceDraftFlow',
  //   title: '深化方案交付',
  //   auth: ['designFeeContract'],
  //   datareskey: 'designFeeContractInitialCase',
  // },
  // {
  //   key: 'designServiceSchemeFlow',
  //   title: '施工方案交付',
  //   auth: ['designFeeContract'],
  //   datareskey: 'designFeeContractService',
  // },
  {
    key: 'submitCollectionFlow',
    title: '提交收款',
    auth: ['designFeeContract', 'designFeeAddContract'],
    datareskey: 'submitCollectionFlow',
    otherAuthFn: (props: any) => {
      return props.record && props.record.elecContractId
    },
  },
  // {
  //   key: 'contractChange',
  //   title: '合同变更',
  //   auth: ['designFeeContract', 'bidGrassContract', 'bidMainContract'],
  //   otherAuthFn: (props: any) => {
  //     return props.record?.canChangeFlag;
  //   },
  //   datareskey: 'bidBtnContractChange',
  // },
  // {
  //   key: 'bidBtnCancelContractChange',
  //   title: '取消合同变更',
  //   auth: ['designFeeContract', 'bidGrassContract', 'bidMainContract'],
  //   otherAuthFn: (props: any) => {
  //     return props.record?.targetChangeHeaderId;
  //   },
  //   datareskey: 'bidBtnCancelContractChange',
  // },
  // {
  //   key: 'signingPromotionAuthority',
  //   title: '签单促销权限',
  //   auth: ['bidMainContract'],
  //   otherAuthFn: (props: any) => {
  //     return props.record?.type == 'bidMainContract' && props.detail?.type == 'overallDecorationType';
  //   },
  //   datareskey: 'signingPromotionAuthority',
  // },
  {
    key: 'houseTypeManage',
    title: '户型管理',
    auth: ['bidMainContract'],
    datareskey: 'budgetHeaderHouseAdmin',
  },
  {
    key: 'printBtn',
    title: '打印',
    auth: ['bidMainContract'],
    otherAuthFn: (props: any) => {
      return !props.record?.printFlag
    },
    datareskey: 'budgetHeaderPrint',
  },
  // {
  //   key: 'applyAddBrands',
  //   title: '申请增加品牌数',
  //   auth: ['bidMainContract'],
  //   otherAuthFn: (props: any) => {
  //     return props.record?.printFlag;
  //   },
  //   datareskey: 'budgetHeaderPrint',
  // },
  {
    key: 'bidAddSoftAddition',
    title: '软装报价',
    auth: ['bidMainContract', 'bidAdditionContract', 'bidProjectAdditionContract'],
    otherAuthFn: (props: any) => {
      return (
        props.record?.perfectSoftFlag && props.record?.roomCount != 0 && !!props.record?.roomCount
      )
    },
    isHidden: true,
    datareskey: 'bidAddSoftAdditionButton',
  },
  // {
  //   key: 'wgQuote',
  //   title: '微改报价',
  //   auth: ['bidMainContract', 'bidAdditionContract'],
  //   otherAuthFn: (props: any) => {
  //     if (props.record.type === 'bidMainContract') {
  //       return props.showWg;
  //     } else {
  //       return true;
  //     }
  //   },
  // },
  // {key: 'paymentCalculation', title: '收款计算', auth: []},
  {
    key: 'downloadAttachment',
    title: '下载复尺附件',
    auth: [
      'bidCabinetContract',
      'bidWardrobeContract',
      'bidProjectCabinetContract',
      'bidProjectWardrobeContract',
    ],
    datareskey: 'QuotaDownloadFileBtn',
    otherAuthFn: (props: any) => {
      return props.record?.scaleAttach
    },
  },
  {
    key: 'uploadAttachment',
    title: '上传复尺附件',
    auth: [
      'bidCabinetContract',
      'bidWardrobeContract',
      'bidProjectCabinetContract',
      'bidProjectWardrobeContract',
    ],
    datareskey: 'QuotaUploadFileBtn',
    otherAuthFn: (props: any) => {
      return !props.record?.scaleAttach
    },
  },
  // {
  //   key: 'resultsConver',
  //   title: '查看业绩',
  //   auth: [
  //     'bidMainContract',
  //     'bidAdditionContract',
  //     'bidCabinetContract',
  //     'bidWardrobeContract',
  //     'bidProjectCabinetContract',
  //   ],
  // },
]
